import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {};

const CRAWL_TYPE = 'text_media_stack';
export default {
  crawlType: CRAWL_TYPE,
  matchTemplates: [
    {
      type: sectionType.sectionImageWithTextCol1,
      tags: [],
      priority: 1,
    },
  ],
};
